import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProductionExternally from '../../components/ProductionExternally';
import { Route } from 'react-router-dom';
import { PRODUCTIONEXTERNALLY } from '../../routes';

const ProductionExternallyRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PRODUCTIONEXTERNALLY}
				render={props => <ProductionExternally {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProductionExternallyRoute;
